module.exports = __webpack_public_path__ + "static/media/Trailer28FT.c04504a2.svg";